module.exports = __webpack_public_path__ + "img/23.c4eec10d.jpg";